/**
 * 共享分页条（全模块列表页统一）· 上一页 / 下一页 + 每页 30/50 + 页码指示。
 *
 * 设计：后端列表多为「只返数组不返 total」→ 用「本页行数 pageCount 是否 = pageSize」判断
 * 有没有下一页（满页=可能还有·不满=最后一页），不依赖精确 total。total 已知（stats）时额外显示。
 * pageCount 必须传**后端原始页行数**（listQuery.data.length），不是客户端再过滤后的行数，
 * 否则本地搜索会把满页误判成最后一页。
 */
export function Pagination({
  page,
  pageSize,
  pageCount,
  total,
  onPage,
  onPageSize,
  pageSizeOptions = [30, 50],
}: {
  page: number;
  pageSize: number;
  pageCount: number;
  total?: number | null;
  onPage: (p: number) => void;
  onPageSize: (s: number) => void;
  pageSizeOptions?: number[];
}) {
  const hasNext = pageCount >= pageSize;
  const btn =
    "h-8 rounded-md border border-slate-200 bg-white px-3 text-[13px] font-medium text-slate-600 hover:bg-slate-50 disabled:opacity-40 disabled:hover:bg-white";
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-1">
      <div className="flex items-center gap-2 text-[13px] text-slate-500">
        <span>每页</span>
        <select
          value={pageSize}
          onChange={(e) => onPageSize(Number(e.target.value))}
          className="h-8 rounded-md border border-slate-200 bg-white px-2 text-[13px]"
        >
          {pageSizeOptions.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
        <span>
          条 · 第 {page} 页（本页 {pageCount} 条{total != null ? ` · 共 ${total} 条` : ""}）
        </span>
      </div>
      <div className="flex items-center gap-2">
        <button type="button" disabled={page <= 1} onClick={() => onPage(Math.max(1, page - 1))} className={btn}>
          ← 上一页
        </button>
        <button type="button" disabled={!hasNext} onClick={() => onPage(page + 1)} className={btn}>
          下一页 →
        </button>
      </div>
    </div>
  );
}
